'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UIFlex;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _FlexConstants = require('./FlexConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = {
  align: _react.PropTypes.oneOf(Object.keys(_FlexConstants.ALIGN_CLASSES)).isRequired,
  alignSelf: _react.PropTypes.oneOf(Object.keys(_FlexConstants.ALIGN_SELF_CLASSES)),
  children: _react.PropTypes.node.isRequired,
  className: _react.PropTypes.string,
  direction: _react.PropTypes.oneOf(Object.keys(_FlexConstants.DIRECTION_CLASSES)).isRequired,
  justify: _react.PropTypes.oneOf(Object.keys(_FlexConstants.JUSTIFY_CLASSES)).isRequired,
  wrap: _react.PropTypes.oneOf(Object.keys(_FlexConstants.WRAP_CLASSES)).isRequired
};

var defaultProps = {
  align: 'start',
  direction: 'row',
  justify: 'start',
  wrap: 'nowrap'
};

function getClassName(_ref) {
  var align = _ref.align,
      alignSelf = _ref.alignSelf,
      className = _ref.className,
      direction = _ref.direction,
      justify = _ref.justify,
      wrap = _ref.wrap;

  return (0, _reactUtils.classNames)('private-flex display-flex', className, _FlexConstants.ALIGN_CLASSES[align], _FlexConstants.DIRECTION_CLASSES[direction], _FlexConstants.JUSTIFY_CLASSES[justify], _FlexConstants.ALIGN_SELF_CLASSES[alignSelf], _FlexConstants.WRAP_CLASSES[wrap]);
}

function UIFlex(props) {
  var align = props.align,
      alignSelf = props.alignSelf,
      children = props.children,
      className = props.className,
      direction = props.direction,
      justify = props.justify,
      wrap = props.wrap,
      rest = _objectWithoutProperties(props, ['align', 'alignSelf', 'children', 'className', 'direction', 'justify', 'wrap']);

  return _react2.default.createElement(
    'div',
    _extends({}, rest, {
      className: getClassName({ align: align, alignSelf: alignSelf, className: className, direction: direction, justify: justify, wrap: wrap }) }),
    children
  );
}

UIFlex.propTypes = propTypes;
UIFlex.defaultProps = defaultProps;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/layout/UIFlex.js
// module id = 251
// module chunks = 0 1